import { combineReducers } from "@reduxjs/toolkit";
import auth from "./auth";
import content from "./content";
import payment from "./payment";

export default combineReducers({
	auth,
	content,
	payment,
});
